import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CourseInfoTable, TotalDiv, SidebySide } from './Course.styles';
import EachCartItem from './Components/EachCartItem.component';

const CourseDetails = ({
  courses = [],
  totalAmount = 0,
  taxAmount = 0,
  selectedTax = null,
  setTaxAmount,
  setTotalAmount,
  setSelectedTax,
  taxRate,
  userId,
}) => {
  // Recalculate tax and total amount whenever selectedTax or courses change
  useEffect(() => {
    if (selectedTax && courses.length > 0) {
      const taxRateForSelected =
        taxRate.find((rate) => rate.province === selectedTax)?.rate || 0;

      // Calculate total price and tax for all courses
      const totalCoursePrice = courses.reduce(
        (acc, course) => acc + course.price,
        0
      );
      const calculatedTax = (totalCoursePrice * taxRateForSelected).toFixed(2);
      const total = (
        parseFloat(totalCoursePrice) + parseFloat(calculatedTax)
      ).toFixed(2);

      setTaxAmount(calculatedTax);
      setTotalAmount(total);
    }
  }, [selectedTax, courses, taxRate, setTaxAmount, setTotalAmount]);

  return (
    <SidebySide>
      <CourseInfoTable>
        {courses?.map((course) => (
          <EachCartItem course={course} key={course._id} userId={userId} />
        ))}
      </CourseInfoTable>
      <TotalDiv>
        <div>
          <p>
            Subtotal{' '}
            <span className="italicSpan">({courses?.length} items)</span>
          </p>
          <p className="italicSpan">
            ${courses.reduce((acc, course) => acc + course.price, 0).toFixed(2)}
          </p>
        </div>
        <div>
          <p style={{ width: '60%' }}>
            Tax{' '}
            <select
              style={{ marginLeft: '0.5rem' }}
              value={selectedTax || ''}
              onChange={(e) => setSelectedTax(e.target.value)}
            >
              <option value="">province</option>
              {taxRate.map((rate) => (
                <option key={rate.province} value={rate.province}>
                  {rate.province}
                </option>
              ))}
            </select>
          </p>
          <p className="italicSpan">${taxAmount}</p>
        </div>
        <p
          className="italicSpan "
          style={{ fontSize: '0.8rem', color: 'var(--infoBlue)' }}
        >
          Select a province for estimated tax prices
        </p>
        <div
          style={{ borderTop: '2px solid var(--grey1)', paddingTop: '0.5rem' }}
        >
          <p>Total </p>
          <p className="italicSpan">${totalAmount}</p>
        </div>
      </TotalDiv>
    </SidebySide>
  );
};

CourseDetails.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      courseId: PropTypes.string,
      courseName: PropTypes.string,
      price: PropTypes.number,
      expiryDate: PropTypes.number,
    })
  ),
  totalAmount: PropTypes.number,
  taxAmount: PropTypes.number,
  selectedTax: PropTypes.string,
  setTaxAmount: PropTypes.func,
  setSelectedTax: PropTypes.func,
  setTotalAmount: PropTypes.func,
  taxRate: PropTypes.arrayOf(
    PropTypes.shape({
      province: PropTypes.string,
      rate: PropTypes.number,
    })
  ),
  userId: PropTypes.string,
};

export default CourseDetails;
